module.exports = __webpack_public_path__ + "img/Lauffs2019.ed121d9a.jpg";